import React from "react";

// Redux
import {useSelector, useDispatch} from "react-redux";
import {createPackageRegular} from "../../../redux/features/packages/regularSlice";

// Routing
import {useHistory} from "react-router-dom";

// Components
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "../../UI/MainPaper";
import PackageRegularForm from "./PackageRegularForm";
import Breadcrumbs from "../../Navigation/Breadcrumbs";

const PackageCardsNew = () => {
  // Redux
  const dispatch = useDispatch();
  const {isLoading} = useSelector(state => state.packageCards);

  // Routing
  const history = useHistory();

  const breadcrumbNameMap = {
    "/packages": "Packages",
    "/packages/regular": "Regular Packages",
    "/packages/regular/new": "New Regular Package",
  };

  const onCancel = () => {
    history.push("/packages/regular");
  };
  const onSubmit = async values => {
    const packageCardObj = {
      id: null,
      ...values,
    };

    const res = await dispatch(createPackageRegular(packageCardObj));
    // If package was created successfully redirect to packages page and show user
    if (!res.error) {
      history.push({
        pathname: "/packages/regular",
        state: {
          showSuccess: true,
          snackbarContent: `Your Package Regular '${packageCardObj.name}' was successfully created!`,
          snackbarLink: `/packages/regular/${res.id}`,
        },
      });
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <Typography component="h1" variant="h5" gutterBottom>
            New Regular Package
          </Typography>
          <PackageRegularForm
            onSubmit={onSubmit}
            onCancel={onCancel}
            isLoading={isLoading}
            submitButtonLabel="Create Regular Package"
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PackageCardsNew;
